import { Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { Pricing } from './pages/Pricing';
import { Success } from './pages/Success';
import { IconProvider } from './components/icons/IconProvider';
import EmergencyApp from './EmergencyApp';
import CookieManager from './components/CookieManager';
import { DevelopedWithBolt } from './components/DevelopedWithBolt';

function App() {
  return (
    <IconProvider>
      <Routes>
        <Route path="/*" element={<EmergencyApp />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/success" element={<Success />} />
      </Routes>
      <CookieManager />
      <DevelopedWithBolt />
      <Toaster />
    </IconProvider>
  );
}

export default App;